import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { stopEventRefs } from "../subjects/stopEvent/refs";
import { callRejectionFacts, callRejectionV2Facts } from "../subjects/stopEvent/callRejectionFacts";

/**
 * The TMS refused the call for a reason the vocabulary has not placed in a family yet; the status fields say which.
 */
export const otherRejectionV1 = tmsEventKind(
  { category: "callRejection", kind: "otherRejection", version: 1 },
  { refs: stopEventRefs, facts: callRejectionFacts },
);

export const OtherRejectionV1Schema = otherRejectionV1.schema;
export const OtherRejectionV1FactsSchema = otherRejectionV1.facts;

export type OtherRejectionV1 = z.infer<typeof OtherRejectionV1Schema>;
export type OtherRejectionV1Facts = z.infer<typeof OtherRejectionV1FactsSchema>;

/**
 * Version 2: the same refusal, plus what the driver's call said — its type, load, trailers, consignee, and lines.
 */
export const otherRejectionV2 = tmsEventKind(
  { category: "callRejection", kind: "otherRejection", version: 2 },
  { refs: stopEventRefs, facts: callRejectionV2Facts },
);

export const OtherRejectionV2Schema = otherRejectionV2.schema;
export const OtherRejectionV2FactsSchema = otherRejectionV2.facts;

export type OtherRejectionV2 = z.infer<typeof OtherRejectionV2Schema>;
export type OtherRejectionV2Facts = z.infer<typeof OtherRejectionV2FactsSchema>;

/** Every version of `otherRejection`, keyed by version. What `catalog.ts` places under `callRejection`. */
export const otherRejection = { 1: otherRejectionV1, 2: otherRejectionV2 } as const;
